import { createPortal } from 'react-dom';

import _ from 'lodash';

// base components
import JxButton from '../../../../JxControls/JxButtons/JxButton';
import { jxScrollbarThin } from '../../../../JxControls/jxScrollbarStyle';
import JxFormResizableBase from '../../../../JxControls/JxForms/JxFormResizableBase';
import JxTitleBar from '../../../../JxControls/JxTitleBar/JxTitleBar';
import '../../../../JxControls/JxTheme.css';

// local components
import { TITLE_BAR_ACTIONS } from './LoadFormConfigDlgTitleBarActions';
import LoadFormConfigDlgBody from './LoadFormConfigDlgBody';
import { createSchema, createEmpty } from './LoadFormConfigDlgSchema';
import FormConfigItemPanel from './FormConfigItemPanel';

import './LoadFormConfigDlg.css';

/**
 * LoadFormConfigDlg — floating dialog.
 * Extends JxForm: drag + bringToTop + Escape-to-close + Joi validation.
 * @param {boolean}  props.open
 * @param {function} props.onClose
 */
export default class LoadFormConfigDlg extends JxFormResizableBase {
    constructor(props) {
        super(props);
        this.name = 'LoadFormConfigDlg';
        this.schema = createSchema();
        this.state = { ...this.state, inputs: createEmpty() };
    }

    componentDidMount() {
        super.componentDidMount();
        this.bringToTop();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (this.props.open && !prevProps.open) {
            this.setState({ inputs: createEmpty() });
        }
    }

    // Literal, hardcoded default — no window.innerWidth centering math, no cache read here
    // (JxFormBase.componentDidMount already does that once, for every window).
    getDefaultGeo() {
        return { top: 180, left: 138, width: 389, height: 291 };
    }

    handleClose = async (action) => {
        try {
            this.props.onClose?.();
        } catch (error) {
            this.logError('handleClose', error.message);
        }
    };

    render() {
        if (!this.props.open) return null;

        const panel = (
            <div {...this.panelProps} style={this.panelStyle} className={`lfcd-panel ${this.panelActiveClass}`}>
                <JxTitleBar
                    id={`${this.name}_titlebar`}
                    title="Load Form Configs"
                    variant="toolwindow"
                    isDraggable={true}
                    dragHandleProps={this.dragHandleProps}
                    actions={TITLE_BAR_ACTIONS(() => this.handleClose(-1))}
                />

                <LoadFormConfigDlgBody inputs={this.state.inputs} errors={this.state.errors} onChange={this.handleChange} />

                <div className={`lfcd-body ${jxScrollbarThin}`}>
                    <FormConfigItemPanel />
                </div>

                <div className="lfcd-footer">
                    <JxButton label="Close" onClick={() => this.handleClose(0)} />
                </div>

                {/* for resizing sides - has to be in this pannelProps */}
                {this.renderResizeHandles()}
            </div>
        );

        return createPortal(panel, document.body);
    }
}
